// src/pages/tenant/Documents.jsx
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  IconButton,
  Modal
} from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import LeaseTemplate from '../../components/LeaseTemplate';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase';

export default function Documents() {
  const [filter, setFilter] = useState('Lease');
  const [openModal, setOpenModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
const [dynamicDocs, setDynamicDocs] = useState([]);

  const documents = [
    {
      id: 'lease-123',
      name: 'Residential Lease Agreement',
      category: 'Lease',
      status: 'Incomplete',
      url: '',
      updated: new Date(),
      size: '89 KB'
    },
    {
      id: 'notice-001',
      name: 'Late Rent Notice',
      category: 'Notice',
      status: 'Complete',
      url: '/sample-notice.pdf',
      updated: new Date(),
      size: '54 KB'
    }
  ];
  useEffect(() => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return;

  const q = query(collection(db, 'documents'), where('uid', '==', user.uid));
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setDynamicDocs(docs);
  });

  return () => unsubscribe();
}, []);

const filteredDocs = [...documents, ...dynamicDocs].filter((doc) => doc.category === filter);
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>Documents</Typography>

      <Paper sx={{ mt: 2, p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <TextField
            select
            label="Category"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            size="small"
            sx={{ minWidth: 200 }}
          >
            <MenuItem value="Lease">Lease</MenuItem>
            <MenuItem value="Notice">Notice</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>NAME</TableCell>
                <TableCell>CATEGORY</TableCell>
                <TableCell>UPDATED</TableCell>
                <TableCell>SIZE</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDocs.map((doc) => (
                <TableRow
                  key={doc.id}
                  hover
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (doc.category === 'Lease' && doc.status === 'Incomplete') {
                      setSelectedDoc(doc);
                      setOpenModal(true);
                    } else {
                      window.open(doc.url, '_blank');
                    }
                  }}
                >
                  <TableCell>
                    <Box display="flex" alignItems="center" gap={1}>
                      <InsertDriveFileIcon color="action" />
                      {doc.name}
                    </Box>
                  </TableCell>
                  <TableCell>{doc.category}</TableCell>
<TableCell>
  {doc.updated instanceof Date
    ? doc.updated.toLocaleDateString()
    : doc.updated?.toDate?.().toLocaleDateString?.() || 'N/A'}
</TableCell>                  <TableCell>{doc.size}</TableCell>
                  <TableCell>
                    <TableCell>
  {doc.status === 'Complete' && doc.url && (
    <IconButton href={doc.url} target="_blank" download>
      <DownloadIcon />
    </IconButton>
  )}
</TableCell>
                  </TableCell>
                </TableRow>
              ))}
              {filteredDocs.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography variant="body2" align="center">
                      No documents found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Lease Modal */}
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          maxHeight: '90vh',
          overflow: 'auto',
          width: '90%',
          maxWidth: '850px',
          p: 4,
          borderRadius: 2
        }}>
          {selectedDoc && (
<LeaseTemplate
  tenantName="Ashley Dotson"
  leaseAddress="750 Hilton St Memphis, TN 38114"
  rent="$1850.00"
  startDate="December 1, 2024"
  endDate="November 30, 2025"
  todayDate={new Date().toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })}
  onClose={() => {
    alert('Lease signed!');
    setOpenModal(false);
  }}
/>
          )}
        </Box>
      </Modal>
    </Box>
  );
}